import { useEffect } from 'react';

function renderContent(text) {
  return text.split('\n').map((line, i) => {
    const trimmed = line.trim();

    // 제X부 — 대제목
    if (/^제\d+부/.test(trimmed)) {
      return (
        <div key={i} style={{ fontSize: '17px', fontWeight: 700, color: '#090909', marginTop: i === 0 ? 0 : '32px', marginBottom: '8px', paddingBottom: '8px', borderBottom: '2px solid #090909' }}>
          {trimmed}
        </div>
      );
    }

    // 제X조 — 소제목
    if (/^제\d+조/.test(trimmed)) {
      return (
        <div key={i} style={{ fontSize: '15px', fontWeight: 600, color: '#090909', marginTop: '24px', marginBottom: '6px' }}>
          {trimmed}
        </div>
      );
    }

    // ※ 강조 문구
    if (trimmed.startsWith('※')) {
      return (
        <div key={i} style={{ fontSize: '13px', fontWeight: 500, color: '#FF9900', marginTop: '8px', marginBottom: '4px' }}>
          {trimmed}
        </div>
      );
    }

    // "동의 문구" (따옴표로 시작)
    if (trimmed.startsWith('"') || trimmed.startsWith('"')) {
      return (
        <div key={i} style={{ fontSize: '13px', fontWeight: 500, color: '#555', background: '#F5F5F7', borderRadius: '6px', padding: '10px 12px', marginTop: '8px' }}>
          {trimmed}
        </div>
      );
    }

    // 빈 줄
    if (trimmed === '') {
      return <div key={i} style={{ height: '8px' }} />;
    }

    // 일반 텍스트
    return (
      <div key={i} style={{ fontSize: '14px', fontWeight: 400, color: '#333', lineHeight: '22px' }}>
        {trimmed}
      </div>
    );
  });
}

function TermsModal({ title, content, onClose }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        width: '560px', maxHeight: '70vh',
        background: '#FFFFFF', borderRadius: '16px',
        display: 'flex', flexDirection: 'column',
        boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '20px 24px', borderBottom: '1px solid #E9E9EC', flexShrink: 0,
        }}>
          <span style={{ fontFamily: 'Pretendard, sans-serif', fontWeight: 600, fontSize: '18px', letterSpacing: '-0.04em', color: '#090909' }}>
            {title}
          </span>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', cursor: 'pointer', padding: '4px',
            fontSize: '20px', color: '#A2A2A2', lineHeight: 1,
          }}>
            ✕
          </button>
        </div>
        {/* Body */}
        <div style={{
          flex: 1, overflowY: 'auto', padding: '24px',
          fontFamily: 'Pretendard, sans-serif', letterSpacing: '-0.04em',
        }}>
          {renderContent(content)}
        </div>
      </div>
    </div>
  );
}

export default TermsModal;
